import type { JSX } from "react";
import { cn } from "./cn";

export interface DateBadgeProps {
  readonly day: string;
  readonly month: string;
  readonly size?: "sm" | "md" | "lg";
}

const sizeMap: Readonly<Record<NonNullable<DateBadgeProps["size"]>, string>> = {
  sm: "w-[30px] min-w-[30px] rounded-md text-[9px]",
  md: "w-12 h-12 rounded-lg text-[11px]",
  lg: "w-16 h-16 rounded-xl text-[11px]",
};

const daySizeMap: Readonly<Record<NonNullable<DateBadgeProps["size"]>, string>> = {
  sm: "text-sm leading-none",
  md: "text-sm",
  lg: "text-lg",
};

/**
 * A date badge showing day number and month abbreviation.
 * Used in meetings (list + detail) and contacts (meeting entries).
 */
export function DateBadge({ day, month, size = "md" }: DateBadgeProps): JSX.Element {
  return (
    <div className={cn("bg-accent text-white flex flex-col items-center justify-center font-semibold uppercase shrink-0", sizeMap[size])}>
      <div className={cn("font-bold", daySizeMap[size])}>{day}</div>
      <div className="text-[10px] uppercase">{month}</div>
    </div>
  );
}
